import { V2TitleSlide } from "./slides/V2TitleSlide";
import { V2OpportunitySlide } from "./slides/V2OpportunitySlide";
import { V2EngineSlide } from "./slides/V2EngineSlide";
import { V2ProofSlide } from "./slides/V2ProofSlide";
import { V2ProductClientsSlide } from "./slides/V2ProductClientsSlide";
import { V2HarnessSlide } from "./slides/V2HarnessSlide";
import { V2BusinessModelSlide } from "./slides/V2BusinessModelSlide";
import { V2UnitEconomicsSlide } from "./slides/V2UnitEconomicsSlide";
import { V2DualTierSlide } from "./slides/V2DualTierSlide";
import { V2MarketSlide } from "./slides/V2MarketSlide";
import { V2BiggerPictureSlide } from "./slides/V2BiggerPictureSlide";
import { V2WhyUsSlide } from "./slides/V2WhyUsSlide";
import { V2CompetitiveLandscapeSlide } from "./slides/V2CompetitiveLandscapeSlide";
import { V2RoadmapSlide } from "./slides/V2RoadmapSlide";
import { V2ValuationBenchmarksSlide } from "./slides/V2ValuationBenchmarksSlide";
import { V2TeamSlide } from "./slides/V2TeamSlide";
import { V2TheAskSlide } from "./slides/V2TheAskSlide";
import { V2ThankYouSlide } from "./slides/V2ThankYouSlide";

export const investorV2SlideComponents = [
  V2TitleSlide,
  V2OpportunitySlide,
  V2EngineSlide,
  V2ProofSlide,
  V2ProductClientsSlide,
  V2HarnessSlide,
  V2BusinessModelSlide,
  V2UnitEconomicsSlide,
  V2DualTierSlide,
  V2MarketSlide,
  V2BiggerPictureSlide,
  V2WhyUsSlide,
  V2CompetitiveLandscapeSlide,
  V2RoadmapSlide,
  V2ValuationBenchmarksSlide,
  V2TeamSlide,
  V2TheAskSlide,
  V2ThankYouSlide,
];
